import BulkOrder from "./BulkOrder";
import SingleOrder from "./SingleOrder";

interface IProps {
  legCount: 2 | 3 | 4;
}

const AddOrderBox = ({ legCount }: IProps) => {
  return (
    <div className="flex flex-col justify-start items-center gap-5">
      <SingleOrder legCount={legCount} />
      <BulkOrder legCount={legCount} />
    </div>
  );
};

export default AddOrderBox;
